<template>
  <div class="flex flex-wrap items-center justify-center gap-2 text-xs sm:text-sm">
    <button
      class="hidden sm:inline-flex px-3 py-1.5 rounded-md border border-gray-200 text-gray-500 hover:text-gray-700 hover:border-gray-300 disabled:opacity-40 disabled:hover:border-gray-200"
      :disabled="isFirstPage"
      @click="goToPage(0)"
    >
      처음
    </button>
    <button
      class="px-2 py-1.5 sm:px-3 rounded-md border border-gray-200 text-gray-500 hover:text-gray-700 hover:border-gray-300 disabled:opacity-40 disabled:hover:border-gray-200"
      :disabled="isFirstPage"
      @click="goToPage(currentPage - 1)"
    >
      이전
    </button>

    <button
      v-for="(page, index) in pageList"
      :key="`${page}-${index}`"
      class="px-2 py-1.5 sm:px-3 rounded-md border border-gray-200"
      :class="page === currentPage ? 'bg-blue-600 text-white border-blue-600' : 'text-gray-600 hover:border-gray-300'"
      :disabled="page === null"
      @click="page !== null ? goToPage(page) : null"
    >
      {{ page === null ? '...' : page + 1 }}
    </button>

    <button
      class="px-2 py-1.5 sm:px-3 rounded-md border border-gray-200 text-gray-500 hover:text-gray-700 hover:border-gray-300 disabled:opacity-40 disabled:hover:border-gray-200"
      :disabled="isLastPage"
      @click="goToPage(currentPage + 1)"
    >
      다음
    </button>
    <button
      class="hidden sm:inline-flex px-3 py-1.5 rounded-md border border-gray-200 text-gray-500 hover:text-gray-700 hover:border-gray-300 disabled:opacity-40 disabled:hover:border-gray-200"
      :disabled="isLastPage"
      @click="goToPage(totalPages - 1)"
    >
      마지막
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  currentPage: number
  totalPages: number
}

const props = defineProps<Props>()

const emit = defineEmits<{
  pageChange: [page: number]
}>()

const isFirstPage = computed(() => props.currentPage <= 0)
const isLastPage = computed(() => props.currentPage >= props.totalPages - 1)

const pageList = computed(() => {
  const total = props.totalPages
  const current = props.currentPage + 1
  const delta = 2

  const range: number[] = []
  for (let i = 1; i <= total; i += 1) {
    if (i === 1 || i === total || (i >= current - delta && i <= current + delta)) {
      range.push(i)
    }
  }

  const pages: Array<number | null> = []
  let last = 0
  range.forEach((page) => {
    if (last && page - last > 1) {
      pages.push(null)
    }
    pages.push(page - 1)
    last = page
  })

  return pages
})

const goToPage = (page: number) => {
  if (page < 0 || page >= props.totalPages) return
  emit('pageChange', page)
}
</script>
